import { switchClasses, type SwitchProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Switch' {}

export default function Switch(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  const rootStyles = (ownerState: SwitchProps) => ({
    padding: 0, // '9px 13px 9px 12px',
    width: 32,
    height: 18,

    ...(ownerState.size === 'small' && {
      padding: 0, //'4px 8px 4px 7px',
      width: 28,
      height: 14,
    }),
    // ...(ownerState.size === 'large' && {
    //   padding: 0, //'4px 8px 4px 7px',
    //   width: 40,
    //   height: 22,
    // }),
    [`& .${switchClasses.thumb}`]: {
      width: 14,
      height: 14,
      boxShadow: 'none',
      color: theme.palette.common.white,
      ...(ownerState.size === 'small' && {
        width: 10,
        height: 10,
      }),
      // ...(ownerState.size === 'large' && {
      //   width: 16,
      //   height: 16,
      // }),
    },
    [`& .${switchClasses.track}`]: {
      opacity: 1,
      borderRadius: 14,
      backgroundColor: theme.palette.grey[300],
    },
    [`& .${switchClasses.switchBase}`]: {
      // left: 3,
      // padding: 12,
      transform: 'translate(2px, 2px)',
      padding: 0,
      ...(ownerState.size === 'small' && {
        transform: 'translate(2px, 2px)',
      }),
      // ...(ownerState.size === 'large' && {
      //   transform: 'translate(3px, 3px)',
      // }),
      [`&.${switchClasses.checked}`]: {
        transform: 'translate(16px, 2px)',
        padding: 0,
        [`&+.${switchClasses.track}`]: {
          opacity: 1,
        },
        ...(ownerState.size === 'small' && {
          transform: 'translate(16px, 2px)',
        }),
        // ...(ownerState.size === 'large' && {
        //   transform: 'translate(21px, 3px)',
        // }),
      },
      [`&.${switchClasses.disabled}`]: {
        [`& .${switchClasses.thumb}`]: {
          opacity: isLight ? 1 : 0.48,
        },
        [`&+.${switchClasses.track}`]: {
          opacity: 0.48,
        },
      },
    },
  });

  return {
    MuiSwitch: {
      defaultProps: {
        size: 'small',
        disableRipple: true,
        color: 'primary',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: SwitchProps }) =>
          rootStyles(ownerState),
      },
    },
  };
}
